import type { ReactNode } from 'react';

interface DocCodeBlockProps {
  children: ReactNode;
  className?: string;
}

export function DocCodeBlock({ children, className = '' }: DocCodeBlockProps) {
  return (
    <pre
      className={
        `overflow-x-auto whitespace-pre-wrap break-words rounded-2xl bg-zinc-950 border border-zinc-800 p-5 text-sm font-mono text-zinc-200 antialiased leading-relaxed shadow-lg ${className}`.trim()
      }
    >
      {children}
    </pre>
  );
}
